// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file cometbft/abci/v1/types.proto (package cometbft.abci.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
import { ConsensusParams } from "../../types/v1/params_pb.js";
import { ProofOps } from "../../crypto/v1/proof_pb.js";
import { PublicKey } from "../../crypto/v1/keys_pb.js";
import { BlockIDFlag } from "../../types/v1/validator_pb.js";

/**
 * Type of the transaction check request.
 *
 * This enumeration is incompatible with the CheckTxType definition in
 * cometbft.abci.v1beta1 and therefore shall not be used in encoding with the same
 * field number.
 *
 * @generated from enum cometbft.abci.v1.CheckTxType
 */
export enum CheckTxType {
  /**
   * Unknown
   *
   * @generated from enum value: CHECK_TX_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Recheck (2nd, 3rd, etc.)
   *
   * @generated from enum value: CHECK_TX_TYPE_RECHECK = 1;
   */
  RECHECK = 1,

  /**
   * Check (1st time)
   *
   * @generated from enum value: CHECK_TX_TYPE_CHECK = 2;
   */
  CHECK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(CheckTxType)
proto3.util.setEnumType(CheckTxType, "cometbft.abci.v1.CheckTxType", [
  { no: 0, name: "CHECK_TX_TYPE_UNKNOWN" },
  { no: 1, name: "CHECK_TX_TYPE_RECHECK" },
  { no: 2, name: "CHECK_TX_TYPE_CHECK" },
]);

/**
 * The result of offering a snapshot.
 *
 * @generated from enum cometbft.abci.v1.OfferSnapshotResult
 */
export enum OfferSnapshotResult {
  /**
   * Unknown result, abort all snapshot restoration
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Snapshot accepted, apply chunks
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_ACCEPT = 1;
   */
  ACCEPT = 1,

  /**
   * Abort all snapshot restoration
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_ABORT = 2;
   */
  ABORT = 2,

  /**
   * Reject this specific snapshot, try others
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_REJECT = 3;
   */
  REJECT = 3,

  /**
   * Reject all snapshots of this format, try others
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_REJECT_FORMAT = 4;
   */
  REJECT_FORMAT = 4,

  /**
   * Reject all snapshots from the sender(s), try others
   *
   * @generated from enum value: OFFER_SNAPSHOT_RESULT_REJECT_SENDER = 5;
   */
  REJECT_SENDER = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(OfferSnapshotResult)
proto3.util.setEnumType(OfferSnapshotResult, "cometbft.abci.v1.OfferSnapshotResult", [
  { no: 0, name: "OFFER_SNAPSHOT_RESULT_UNKNOWN" },
  { no: 1, name: "OFFER_SNAPSHOT_RESULT_ACCEPT" },
  { no: 2, name: "OFFER_SNAPSHOT_RESULT_ABORT" },
  { no: 3, name: "OFFER_SNAPSHOT_RESULT_REJECT" },
  { no: 4, name: "OFFER_SNAPSHOT_RESULT_REJECT_FORMAT" },
  { no: 5, name: "OFFER_SNAPSHOT_RESULT_REJECT_SENDER" },
]);

/**
 * The result of applying a snapshot chunk.
 *
 * @generated from enum cometbft.abci.v1.ApplySnapshotChunkResult
 */
export enum ApplySnapshotChunkResult {
  /**
   * Unknown result, abort all snapshot restoration
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Chunk successfully accepted
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_ACCEPT = 1;
   */
  ACCEPT = 1,

  /**
   * Abort all snapshot restoration
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_ABORT = 2;
   */
  ABORT = 2,

  /**
   * Retry chunk (combine with refetch and reject)
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_RETRY = 3;
   */
  RETRY = 3,

  /**
   * Retry snapshot (combine with refetch and reject)
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_RETRY_SNAPSHOT = 4;
   */
  RETRY_SNAPSHOT = 4,

  /**
   * Reject this snapshot, try others
   *
   * @generated from enum value: APPLY_SNAPSHOT_CHUNK_RESULT_REJECT_SNAPSHOT = 5;
   */
  REJECT_SNAPSHOT = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(ApplySnapshotChunkResult)
proto3.util.setEnumType(ApplySnapshotChunkResult, "cometbft.abci.v1.ApplySnapshotChunkResult", [
  { no: 0, name: "APPLY_SNAPSHOT_CHUNK_RESULT_UNKNOWN" },
  { no: 1, name: "APPLY_SNAPSHOT_CHUNK_RESULT_ACCEPT" },
  { no: 2, name: "APPLY_SNAPSHOT_CHUNK_RESULT_ABORT" },
  { no: 3, name: "APPLY_SNAPSHOT_CHUNK_RESULT_RETRY" },
  { no: 4, name: "APPLY_SNAPSHOT_CHUNK_RESULT_RETRY_SNAPSHOT" },
  { no: 5, name: "APPLY_SNAPSHOT_CHUNK_RESULT_REJECT_SNAPSHOT" },
]);

/**
 * ProcessProposalStatus is the status of the proposal processing.
 *
 * @generated from enum cometbft.abci.v1.ProcessProposalStatus
 */
export enum ProcessProposalStatus {
  /**
   * Unknown
   *
   * @generated from enum value: PROCESS_PROPOSAL_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Accepted
   *
   * @generated from enum value: PROCESS_PROPOSAL_STATUS_ACCEPT = 1;
   */
  ACCEPT = 1,

  /**
   * Rejected
   *
   * @generated from enum value: PROCESS_PROPOSAL_STATUS_REJECT = 2;
   */
  REJECT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ProcessProposalStatus)
proto3.util.setEnumType(ProcessProposalStatus, "cometbft.abci.v1.ProcessProposalStatus", [
  { no: 0, name: "PROCESS_PROPOSAL_STATUS_UNKNOWN" },
  { no: 1, name: "PROCESS_PROPOSAL_STATUS_ACCEPT" },
  { no: 2, name: "PROCESS_PROPOSAL_STATUS_REJECT" },
]);

/**
 * VerifyVoteExtensionStatus is the status of the vote extension verification.
 *
 * @generated from enum cometbft.abci.v1.VerifyVoteExtensionStatus
 */
export enum VerifyVoteExtensionStatus {
  /**
   * Unknown
   *
   * @generated from enum value: VERIFY_VOTE_EXTENSION_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Accepted
   *
   * @generated from enum value: VERIFY_VOTE_EXTENSION_STATUS_ACCEPT = 1;
   */
  ACCEPT = 1,

  /**
   * Rejecting the vote extension will reject the entire precommit by the sender.
   * Incorrectly implementing this thus has liveness implications as it may affect
   * CometBFT's ability to receive 2/3+ valid votes to finalize the block.
   * Honest nodes should never be rejected.
   *
   * @generated from enum value: VERIFY_VOTE_EXTENSION_STATUS_REJECT = 2;
   */
  REJECT = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(VerifyVoteExtensionStatus)
proto3.util.setEnumType(VerifyVoteExtensionStatus, "cometbft.abci.v1.VerifyVoteExtensionStatus", [
  { no: 0, name: "VERIFY_VOTE_EXTENSION_STATUS_UNKNOWN" },
  { no: 1, name: "VERIFY_VOTE_EXTENSION_STATUS_ACCEPT" },
  { no: 2, name: "VERIFY_VOTE_EXTENSION_STATUS_REJECT" },
]);

/**
 * The type of misbehavior committed by a validator.
 *
 * @generated from enum cometbft.abci.v1.MisbehaviorType
 */
export enum MisbehaviorType {
  /**
   * Unknown
   *
   * @generated from enum value: MISBEHAVIOR_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * Duplicate vote
   *
   * @generated from enum value: MISBEHAVIOR_TYPE_DUPLICATE_VOTE = 1;
   */
  DUPLICATE_VOTE = 1,

  /**
   * Light client attack
   *
   * @generated from enum value: MISBEHAVIOR_TYPE_LIGHT_CLIENT_ATTACK = 2;
   */
  LIGHT_CLIENT_ATTACK = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(MisbehaviorType)
proto3.util.setEnumType(MisbehaviorType, "cometbft.abci.v1.MisbehaviorType", [
  { no: 0, name: "MISBEHAVIOR_TYPE_UNKNOWN" },
  { no: 1, name: "MISBEHAVIOR_TYPE_DUPLICATE_VOTE" },
  { no: 2, name: "MISBEHAVIOR_TYPE_LIGHT_CLIENT_ATTACK" },
]);

/**
 * Request represents a request to the ABCI application.
 *
 * @generated from message cometbft.abci.v1.Request
 */
export class Request extends Message<Request> {
  /**
   * Sum of all possible messages.
   *
   * @generated from oneof cometbft.abci.v1.Request.value
   */
  value: {
    /**
     * @generated from field: cometbft.abci.v1.EchoRequest echo = 1;
     */
    value: EchoRequest;
    case: "echo";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.FlushRequest flush = 2;
     */
    value: FlushRequest;
    case: "flush";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.InfoRequest info = 3;
     */
    value: InfoRequest;
    case: "info";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.InitChainRequest init_chain = 5;
     */
    value: InitChainRequest;
    case: "initChain";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.QueryRequest query = 6;
     */
    value: QueryRequest;
    case: "query";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.CheckTxRequest check_tx = 8;
     */
    value: CheckTxRequest;
    case: "checkTx";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.CommitRequest commit = 11;
     */
    value: CommitRequest;
    case: "commit";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ListSnapshotsRequest list_snapshots = 12;
     */
    value: ListSnapshotsRequest;
    case: "listSnapshots";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.OfferSnapshotRequest offer_snapshot = 13;
     */
    value: OfferSnapshotRequest;
    case: "offerSnapshot";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.LoadSnapshotChunkRequest load_snapshot_chunk = 14;
     */
    value: LoadSnapshotChunkRequest;
    case: "loadSnapshotChunk";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ApplySnapshotChunkRequest apply_snapshot_chunk = 15;
     */
    value: ApplySnapshotChunkRequest;
    case: "applySnapshotChunk";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.PrepareProposalRequest prepare_proposal = 16;
     */
    value: PrepareProposalRequest;
    case: "prepareProposal";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ProcessProposalRequest process_proposal = 17;
     */
    value: ProcessProposalRequest;
    case: "processProposal";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ExtendVoteRequest extend_vote = 18;
     */
    value: ExtendVoteRequest;
    case: "extendVote";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.VerifyVoteExtensionRequest verify_vote_extension = 19;
     */
    value: VerifyVoteExtensionRequest;
    case: "verifyVoteExtension";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.FinalizeBlockRequest finalize_block = 20;
     */
    value: FinalizeBlockRequest;
    case: "finalizeBlock";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "echo", kind: "message", T: EchoRequest, oneof: "value" },
    { no: 2, name: "flush", kind: "message", T: FlushRequest, oneof: "value" },
    { no: 3, name: "info", kind: "message", T: InfoRequest, oneof: "value" },
    { no: 5, name: "init_chain", kind: "message", T: InitChainRequest, oneof: "value" },
    { no: 6, name: "query", kind: "message", T: QueryRequest, oneof: "value" },
    { no: 8, name: "check_tx", kind: "message", T: CheckTxRequest, oneof: "value" },
    { no: 11, name: "commit", kind: "message", T: CommitRequest, oneof: "value" },
    { no: 12, name: "list_snapshots", kind: "message", T: ListSnapshotsRequest, oneof: "value" },
    { no: 13, name: "offer_snapshot", kind: "message", T: OfferSnapshotRequest, oneof: "value" },
    { no: 14, name: "load_snapshot_chunk", kind: "message", T: LoadSnapshotChunkRequest, oneof: "value" },
    { no: 15, name: "apply_snapshot_chunk", kind: "message", T: ApplySnapshotChunkRequest, oneof: "value" },
    { no: 16, name: "prepare_proposal", kind: "message", T: PrepareProposalRequest, oneof: "value" },
    { no: 17, name: "process_proposal", kind: "message", T: ProcessProposalRequest, oneof: "value" },
    { no: 18, name: "extend_vote", kind: "message", T: ExtendVoteRequest, oneof: "value" },
    { no: 19, name: "verify_vote_extension", kind: "message", T: VerifyVoteExtensionRequest, oneof: "value" },
    { no: 20, name: "finalize_block", kind: "message", T: FinalizeBlockRequest, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Request {
    return new Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Request {
    return new Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Request {
    return new Request().fromJsonString(jsonString, options);
  }

  static equals(a: Request | PlainMessage<Request> | undefined, b: Request | PlainMessage<Request> | undefined): boolean {
    return proto3.util.equals(Request, a, b);
  }
}

/**
 * EchoRequest is a request to "echo" the given string.
 *
 * @generated from message cometbft.abci.v1.EchoRequest
 */
export class EchoRequest extends Message<EchoRequest> {
  /**
   * @generated from field: string message = 1;
   */
  message = "";

  constructor(data?: PartialMessage<EchoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.EchoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EchoRequest {
    return new EchoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EchoRequest {
    return new EchoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EchoRequest {
    return new EchoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EchoRequest | PlainMessage<EchoRequest> | undefined, b: EchoRequest | PlainMessage<EchoRequest> | undefined): boolean {
    return proto3.util.equals(EchoRequest, a, b);
  }
}

/**
 * FlushRequest is a request to flush the write buffer.
 *
 * @generated from message cometbft.abci.v1.FlushRequest
 */
export class FlushRequest extends Message<FlushRequest> {
  constructor(data?: PartialMessage<FlushRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.FlushRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlushRequest {
    return new FlushRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlushRequest {
    return new FlushRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlushRequest {
    return new FlushRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FlushRequest | PlainMessage<FlushRequest> | undefined, b: FlushRequest | PlainMessage<FlushRequest> | undefined): boolean {
    return proto3.util.equals(FlushRequest, a, b);
  }
}

/**
 * InfoRequest is a request for the ABCI application version.
 *
 * @generated from message cometbft.abci.v1.InfoRequest
 */
export class InfoRequest extends Message<InfoRequest> {
  /**
   * @generated from field: string version = 1;
   */
  version = "";

  /**
   * @generated from field: uint64 block_version = 2;
   */
  blockVersion = protoInt64.zero;

  /**
   * @generated from field: uint64 p2p_version = 3;
   */
  p2pVersion = protoInt64.zero;

  /**
   * @generated from field: string abci_version = 4;
   */
  abciVersion = "";

  constructor(data?: PartialMessage<InfoRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.InfoRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "block_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "p2p_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "abci_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InfoRequest {
    return new InfoRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InfoRequest {
    return new InfoRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InfoRequest {
    return new InfoRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InfoRequest | PlainMessage<InfoRequest> | undefined, b: InfoRequest | PlainMessage<InfoRequest> | undefined): boolean {
    return proto3.util.equals(InfoRequest, a, b);
  }
}

/**
 * InitChainRequest is a request to initialize the blockchain.
 *
 * @generated from message cometbft.abci.v1.InitChainRequest
 */
export class InitChainRequest extends Message<InitChainRequest> {
  /**
   * @generated from field: google.protobuf.Timestamp time = 1;
   */
  time?: Timestamp;

  /**
   * @generated from field: string chain_id = 2;
   */
  chainId = "";

  /**
   * @generated from field: cometbft.types.v1.ConsensusParams consensus_params = 3;
   */
  consensusParams?: ConsensusParams;

  /**
   * @generated from field: repeated cometbft.abci.v1.ValidatorUpdate validators = 4;
   */
  validators: ValidatorUpdate[] = [];

  /**
   * @generated from field: bytes app_state_bytes = 5;
   */
  appStateBytes = new Uint8Array(0);

  /**
   * @generated from field: int64 initial_height = 6;
   */
  initialHeight = protoInt64.zero;

  constructor(data?: PartialMessage<InitChainRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.InitChainRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "chain_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "consensus_params", kind: "message", T: ConsensusParams },
    { no: 4, name: "validators", kind: "message", T: ValidatorUpdate, repeated: true },
    { no: 5, name: "app_state_bytes", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "initial_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitChainRequest {
    return new InitChainRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitChainRequest {
    return new InitChainRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitChainRequest {
    return new InitChainRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitChainRequest | PlainMessage<InitChainRequest> | undefined, b: InitChainRequest | PlainMessage<InitChainRequest> | undefined): boolean {
    return proto3.util.equals(InitChainRequest, a, b);
  }
}

/**
 * QueryRequest is a request to query the application state.
 *
 * @generated from message cometbft.abci.v1.QueryRequest
 */
export class QueryRequest extends Message<QueryRequest> {
  /**
   * @generated from field: bytes data = 1;
   */
  data = new Uint8Array(0);

  /**
   * @generated from field: string path = 2;
   */
  path = "";

  /**
   * @generated from field: int64 height = 3;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: bool prove = 4;
   */
  prove = false;

  constructor(data?: PartialMessage<QueryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.QueryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "prove", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryRequest {
    return new QueryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryRequest {
    return new QueryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryRequest {
    return new QueryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: QueryRequest | PlainMessage<QueryRequest> | undefined, b: QueryRequest | PlainMessage<QueryRequest> | undefined): boolean {
    return proto3.util.equals(QueryRequest, a, b);
  }
}

/**
 * CheckTxRequest is a request to check that the transaction is valid.
 *
 * @generated from message cometbft.abci.v1.CheckTxRequest
 */
export class CheckTxRequest extends Message<CheckTxRequest> {
  /**
   * @generated from field: bytes tx = 1;
   */
  tx = new Uint8Array(0);

  /**
   * @generated from field: cometbft.abci.v1.CheckTxType type = 3;
   */
  type = CheckTxType.UNKNOWN;

  constructor(data?: PartialMessage<CheckTxRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.CheckTxRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "tx", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "type", kind: "enum", T: proto3.getEnumType(CheckTxType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckTxRequest {
    return new CheckTxRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckTxRequest {
    return new CheckTxRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckTxRequest {
    return new CheckTxRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CheckTxRequest | PlainMessage<CheckTxRequest> | undefined, b: CheckTxRequest | PlainMessage<CheckTxRequest> | undefined): boolean {
    return proto3.util.equals(CheckTxRequest, a, b);
  }
}

/**
 * CommitRequest is a request to commit the pending application state.
 *
 * @generated from message cometbft.abci.v1.CommitRequest
 */
export class CommitRequest extends Message<CommitRequest> {
  constructor(data?: PartialMessage<CommitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.CommitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommitRequest {
    return new CommitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommitRequest {
    return new CommitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommitRequest {
    return new CommitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CommitRequest | PlainMessage<CommitRequest> | undefined, b: CommitRequest | PlainMessage<CommitRequest> | undefined): boolean {
    return proto3.util.equals(CommitRequest, a, b);
  }
}

/**
 * Request to list available snapshots.
 *
 * @generated from message cometbft.abci.v1.ListSnapshotsRequest
 */
export class ListSnapshotsRequest extends Message<ListSnapshotsRequest> {
  constructor(data?: PartialMessage<ListSnapshotsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ListSnapshotsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSnapshotsRequest {
    return new ListSnapshotsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSnapshotsRequest {
    return new ListSnapshotsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSnapshotsRequest {
    return new ListSnapshotsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSnapshotsRequest | PlainMessage<ListSnapshotsRequest> | undefined, b: ListSnapshotsRequest | PlainMessage<ListSnapshotsRequest> | undefined): boolean {
    return proto3.util.equals(ListSnapshotsRequest, a, b);
  }
}

/**
 * Request offering a snapshot to the application.
 *
 * @generated from message cometbft.abci.v1.OfferSnapshotRequest
 */
export class OfferSnapshotRequest extends Message<OfferSnapshotRequest> {
  /**
   * snapshot offered by peers
   *
   * @generated from field: cometbft.abci.v1.Snapshot snapshot = 1;
   */
  snapshot?: Snapshot;

  /**
   * light client-verified app hash for snapshot height
   *
   * @generated from field: bytes app_hash = 2;
   */
  appHash = new Uint8Array(0);

  constructor(data?: PartialMessage<OfferSnapshotRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.OfferSnapshotRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshot", kind: "message", T: Snapshot },
    { no: 2, name: "app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferSnapshotRequest {
    return new OfferSnapshotRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferSnapshotRequest {
    return new OfferSnapshotRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferSnapshotRequest {
    return new OfferSnapshotRequest().fromJsonString(jsonString, options);
  }

  static equals(a: OfferSnapshotRequest | PlainMessage<OfferSnapshotRequest> | undefined, b: OfferSnapshotRequest | PlainMessage<OfferSnapshotRequest> | undefined): boolean {
    return proto3.util.equals(OfferSnapshotRequest, a, b);
  }
}

/**
 * Request to load a snapshot chunk.
 *
 * @generated from message cometbft.abci.v1.LoadSnapshotChunkRequest
 */
export class LoadSnapshotChunkRequest extends Message<LoadSnapshotChunkRequest> {
  /**
   * @generated from field: uint64 height = 1;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: uint32 format = 2;
   */
  format = 0;

  /**
   * @generated from field: uint32 chunk = 3;
   */
  chunk = 0;

  constructor(data?: PartialMessage<LoadSnapshotChunkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.LoadSnapshotChunkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "format", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "chunk", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LoadSnapshotChunkRequest {
    return new LoadSnapshotChunkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LoadSnapshotChunkRequest {
    return new LoadSnapshotChunkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LoadSnapshotChunkRequest {
    return new LoadSnapshotChunkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: LoadSnapshotChunkRequest | PlainMessage<LoadSnapshotChunkRequest> | undefined, b: LoadSnapshotChunkRequest | PlainMessage<LoadSnapshotChunkRequest> | undefined): boolean {
    return proto3.util.equals(LoadSnapshotChunkRequest, a, b);
  }
}

/**
 * Request to apply a snapshot chunk.
 *
 * @generated from message cometbft.abci.v1.ApplySnapshotChunkRequest
 */
export class ApplySnapshotChunkRequest extends Message<ApplySnapshotChunkRequest> {
  /**
   * @generated from field: uint32 index = 1;
   */
  index = 0;

  /**
   * @generated from field: bytes chunk = 2;
   */
  chunk = new Uint8Array(0);

  /**
   * @generated from field: string sender = 3;
   */
  sender = "";

  constructor(data?: PartialMessage<ApplySnapshotChunkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ApplySnapshotChunkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "index", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "chunk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "sender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplySnapshotChunkRequest {
    return new ApplySnapshotChunkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplySnapshotChunkRequest {
    return new ApplySnapshotChunkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplySnapshotChunkRequest {
    return new ApplySnapshotChunkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ApplySnapshotChunkRequest | PlainMessage<ApplySnapshotChunkRequest> | undefined, b: ApplySnapshotChunkRequest | PlainMessage<ApplySnapshotChunkRequest> | undefined): boolean {
    return proto3.util.equals(ApplySnapshotChunkRequest, a, b);
  }
}

/**
 * PrepareProposalRequest is a request for the ABCI application to prepare a new
 * block proposal.
 *
 * @generated from message cometbft.abci.v1.PrepareProposalRequest
 */
export class PrepareProposalRequest extends Message<PrepareProposalRequest> {
  /**
   * the modified transactions cannot exceed this size.
   *
   * @generated from field: int64 max_tx_bytes = 1;
   */
  maxTxBytes = protoInt64.zero;

  /**
   * txs is an array of transactions that will be included in a block,
   * sent to the app for possible modifications.
   *
   * @generated from field: repeated bytes txs = 2;
   */
  txs: Uint8Array[] = [];

  /**
   * @generated from field: cometbft.abci.v1.ExtendedCommitInfo local_last_commit = 3;
   */
  localLastCommit?: ExtendedCommitInfo;

  /**
   * @generated from field: repeated cometbft.abci.v1.Misbehavior misbehavior = 4;
   */
  misbehavior: Misbehavior[] = [];

  /**
   * @generated from field: int64 height = 5;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp time = 6;
   */
  time?: Timestamp;

  /**
   * @generated from field: bytes next_validators_hash = 7;
   */
  nextValidatorsHash = new Uint8Array(0);

  /**
   * address of the public key of the validator proposing the block.
   *
   * @generated from field: bytes proposer_address = 8;
   */
  proposerAddress = new Uint8Array(0);

  constructor(data?: PartialMessage<PrepareProposalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.PrepareProposalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_tx_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "txs", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
    { no: 3, name: "local_last_commit", kind: "message", T: ExtendedCommitInfo },
    { no: 4, name: "misbehavior", kind: "message", T: Misbehavior, repeated: true },
    { no: 5, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "time", kind: "message", T: Timestamp },
    { no: 7, name: "next_validators_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proposer_address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrepareProposalRequest {
    return new PrepareProposalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrepareProposalRequest {
    return new PrepareProposalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrepareProposalRequest {
    return new PrepareProposalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: PrepareProposalRequest | PlainMessage<PrepareProposalRequest> | undefined, b: PrepareProposalRequest | PlainMessage<PrepareProposalRequest> | undefined): boolean {
    return proto3.util.equals(PrepareProposalRequest, a, b);
  }
}

/**
 * ProcessProposalRequest is a request for the ABCI application to process a proposal
 * received from another validator.
 *
 * @generated from message cometbft.abci.v1.ProcessProposalRequest
 */
export class ProcessProposalRequest extends Message<ProcessProposalRequest> {
  /**
   * @generated from field: repeated bytes txs = 1;
   */
  txs: Uint8Array[] = [];

  /**
   * @generated from field: cometbft.abci.v1.CommitInfo proposed_last_commit = 2;
   */
  proposedLastCommit?: CommitInfo;

  /**
   * @generated from field: repeated cometbft.abci.v1.Misbehavior misbehavior = 3;
   */
  misbehavior: Misbehavior[] = [];

  /**
   * Merkle root hash of the fields of the proposed block.
   *
   * @generated from field: bytes hash = 4;
   */
  hash = new Uint8Array(0);

  /**
   * @generated from field: int64 height = 5;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp time = 6;
   */
  time?: Timestamp;

  /**
   * @generated from field: bytes next_validators_hash = 7;
   */
  nextValidatorsHash = new Uint8Array(0);

  /**
   * address of the public key of the original proposer of the block.
   *
   * @generated from field: bytes proposer_address = 8;
   */
  proposerAddress = new Uint8Array(0);

  constructor(data?: PartialMessage<ProcessProposalRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ProcessProposalRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "txs", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
    { no: 2, name: "proposed_last_commit", kind: "message", T: CommitInfo },
    { no: 3, name: "misbehavior", kind: "message", T: Misbehavior, repeated: true },
    { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "time", kind: "message", T: Timestamp },
    { no: 7, name: "next_validators_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proposer_address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessProposalRequest {
    return new ProcessProposalRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessProposalRequest {
    return new ProcessProposalRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessProposalRequest {
    return new ProcessProposalRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessProposalRequest | PlainMessage<ProcessProposalRequest> | undefined, b: ProcessProposalRequest | PlainMessage<ProcessProposalRequest> | undefined): boolean {
    return proto3.util.equals(ProcessProposalRequest, a, b);
  }
}

/**
 * ExtendVoteRequest extends a precommit vote with application-injected data.
 *
 * @generated from message cometbft.abci.v1.ExtendVoteRequest
 */
export class ExtendVoteRequest extends Message<ExtendVoteRequest> {
  /**
   * the hash of the block that this vote may be referring to
   *
   * @generated from field: bytes hash = 1;
   */
  hash = new Uint8Array(0);

  /**
   * the height of the extended vote
   *
   * @generated from field: int64 height = 2;
   */
  height = protoInt64.zero;

  /**
   * info of the block that this vote may be referring to
   *
   * @generated from field: google.protobuf.Timestamp time = 3;
   */
  time?: Timestamp;

  /**
   * @generated from field: repeated bytes txs = 4;
   */
  txs: Uint8Array[] = [];

  /**
   * @generated from field: cometbft.abci.v1.CommitInfo proposed_last_commit = 5;
   */
  proposedLastCommit?: CommitInfo;

  /**
   * @generated from field: repeated cometbft.abci.v1.Misbehavior misbehavior = 6;
   */
  misbehavior: Misbehavior[] = [];

  /**
   * @generated from field: bytes next_validators_hash = 7;
   */
  nextValidatorsHash = new Uint8Array(0);

  /**
   * address of the public key of the original proposer of the block.
   *
   * @generated from field: bytes proposer_address = 8;
   */
  proposerAddress = new Uint8Array(0);

  constructor(data?: PartialMessage<ExtendVoteRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExtendVoteRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "time", kind: "message", T: Timestamp },
    { no: 4, name: "txs", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
    { no: 5, name: "proposed_last_commit", kind: "message", T: CommitInfo },
    { no: 6, name: "misbehavior", kind: "message", T: Misbehavior, repeated: true },
    { no: 7, name: "next_validators_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proposer_address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendVoteRequest {
    return new ExtendVoteRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendVoteRequest {
    return new ExtendVoteRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendVoteRequest {
    return new ExtendVoteRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendVoteRequest | PlainMessage<ExtendVoteRequest> | undefined, b: ExtendVoteRequest | PlainMessage<ExtendVoteRequest> | undefined): boolean {
    return proto3.util.equals(ExtendVoteRequest, a, b);
  }
}

/**
 * VerifyVoteExtensionRequest is a request for the application to verify a vote extension
 * produced by a different validator.
 *
 * @generated from message cometbft.abci.v1.VerifyVoteExtensionRequest
 */
export class VerifyVoteExtensionRequest extends Message<VerifyVoteExtensionRequest> {
  /**
   * the hash of the block that this received vote corresponds to
   *
   * @generated from field: bytes hash = 1;
   */
  hash = new Uint8Array(0);

  /**
   * the validator that signed the vote extension
   *
   * @generated from field: bytes validator_address = 2;
   */
  validatorAddress = new Uint8Array(0);

  /**
   * @generated from field: int64 height = 3;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: bytes vote_extension = 4;
   */
  voteExtension = new Uint8Array(0);

  constructor(data?: PartialMessage<VerifyVoteExtensionRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.VerifyVoteExtensionRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "validator_address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "vote_extension", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyVoteExtensionRequest {
    return new VerifyVoteExtensionRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyVoteExtensionRequest {
    return new VerifyVoteExtensionRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyVoteExtensionRequest {
    return new VerifyVoteExtensionRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyVoteExtensionRequest | PlainMessage<VerifyVoteExtensionRequest> | undefined, b: VerifyVoteExtensionRequest | PlainMessage<VerifyVoteExtensionRequest> | undefined): boolean {
    return proto3.util.equals(VerifyVoteExtensionRequest, a, b);
  }
}

/**
 * FinalizeBlockRequest is a request to finalize the block.
 *
 * @generated from message cometbft.abci.v1.FinalizeBlockRequest
 */
export class FinalizeBlockRequest extends Message<FinalizeBlockRequest> {
  /**
   * @generated from field: repeated bytes txs = 1;
   */
  txs: Uint8Array[] = [];

  /**
   * @generated from field: cometbft.abci.v1.CommitInfo decided_last_commit = 2;
   */
  decidedLastCommit?: CommitInfo;

  /**
   * @generated from field: repeated cometbft.abci.v1.Misbehavior misbehavior = 3;
   */
  misbehavior: Misbehavior[] = [];

  /**
   * Merkle root hash of the fields of the decided block.
   *
   * @generated from field: bytes hash = 4;
   */
  hash = new Uint8Array(0);

  /**
   * @generated from field: int64 height = 5;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: google.protobuf.Timestamp time = 6;
   */
  time?: Timestamp;

  /**
   * @generated from field: bytes next_validators_hash = 7;
   */
  nextValidatorsHash = new Uint8Array(0);

  /**
   * address of the public key of the original proposer of the block.
   *
   * @generated from field: bytes proposer_address = 8;
   */
  proposerAddress = new Uint8Array(0);

  constructor(data?: PartialMessage<FinalizeBlockRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.FinalizeBlockRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "txs", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
    { no: 2, name: "decided_last_commit", kind: "message", T: CommitInfo },
    { no: 3, name: "misbehavior", kind: "message", T: Misbehavior, repeated: true },
    { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "time", kind: "message", T: Timestamp },
    { no: 7, name: "next_validators_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proposer_address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FinalizeBlockRequest {
    return new FinalizeBlockRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FinalizeBlockRequest {
    return new FinalizeBlockRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FinalizeBlockRequest {
    return new FinalizeBlockRequest().fromJsonString(jsonString, options);
  }

  static equals(a: FinalizeBlockRequest | PlainMessage<FinalizeBlockRequest> | undefined, b: FinalizeBlockRequest | PlainMessage<FinalizeBlockRequest> | undefined): boolean {
    return proto3.util.equals(FinalizeBlockRequest, a, b);
  }
}

/**
 * Response represents a response from the ABCI application.
 *
 * @generated from message cometbft.abci.v1.Response
 */
export class Response extends Message<Response> {
  /**
   * Sum of all possible messages.
   *
   * @generated from oneof cometbft.abci.v1.Response.value
   */
  value: {
    /**
     * @generated from field: cometbft.abci.v1.ExceptionResponse exception = 1;
     */
    value: ExceptionResponse;
    case: "exception";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.EchoResponse echo = 2;
     */
    value: EchoResponse;
    case: "echo";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.FlushResponse flush = 3;
     */
    value: FlushResponse;
    case: "flush";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.InfoResponse info = 4;
     */
    value: InfoResponse;
    case: "info";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.InitChainResponse init_chain = 6;
     */
    value: InitChainResponse;
    case: "initChain";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.QueryResponse query = 7;
     */
    value: QueryResponse;
    case: "query";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.CheckTxResponse check_tx = 9;
     */
    value: CheckTxResponse;
    case: "checkTx";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.CommitResponse commit = 12;
     */
    value: CommitResponse;
    case: "commit";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ListSnapshotsResponse list_snapshots = 13;
     */
    value: ListSnapshotsResponse;
    case: "listSnapshots";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.OfferSnapshotResponse offer_snapshot = 14;
     */
    value: OfferSnapshotResponse;
    case: "offerSnapshot";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.LoadSnapshotChunkResponse load_snapshot_chunk = 15;
     */
    value: LoadSnapshotChunkResponse;
    case: "loadSnapshotChunk";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ApplySnapshotChunkResponse apply_snapshot_chunk = 16;
     */
    value: ApplySnapshotChunkResponse;
    case: "applySnapshotChunk";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.PrepareProposalResponse prepare_proposal = 17;
     */
    value: PrepareProposalResponse;
    case: "prepareProposal";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ProcessProposalResponse process_proposal = 18;
     */
    value: ProcessProposalResponse;
    case: "processProposal";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.ExtendVoteResponse extend_vote = 19;
     */
    value: ExtendVoteResponse;
    case: "extendVote";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.VerifyVoteExtensionResponse verify_vote_extension = 20;
     */
    value: VerifyVoteExtensionResponse;
    case: "verifyVoteExtension";
  } | {
    /**
     * @generated from field: cometbft.abci.v1.FinalizeBlockResponse finalize_block = 21;
     */
    value: FinalizeBlockResponse;
    case: "finalizeBlock";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "exception", kind: "message", T: ExceptionResponse, oneof: "value" },
    { no: 2, name: "echo", kind: "message", T: EchoResponse, oneof: "value" },
    { no: 3, name: "flush", kind: "message", T: FlushResponse, oneof: "value" },
    { no: 4, name: "info", kind: "message", T: InfoResponse, oneof: "value" },
    { no: 6, name: "init_chain", kind: "message", T: InitChainResponse, oneof: "value" },
    { no: 7, name: "query", kind: "message", T: QueryResponse, oneof: "value" },
    { no: 9, name: "check_tx", kind: "message", T: CheckTxResponse, oneof: "value" },
    { no: 12, name: "commit", kind: "message", T: CommitResponse, oneof: "value" },
    { no: 13, name: "list_snapshots", kind: "message", T: ListSnapshotsResponse, oneof: "value" },
    { no: 14, name: "offer_snapshot", kind: "message", T: OfferSnapshotResponse, oneof: "value" },
    { no: 15, name: "load_snapshot_chunk", kind: "message", T: LoadSnapshotChunkResponse, oneof: "value" },
    { no: 16, name: "apply_snapshot_chunk", kind: "message", T: ApplySnapshotChunkResponse, oneof: "value" },
    { no: 17, name: "prepare_proposal", kind: "message", T: PrepareProposalResponse, oneof: "value" },
    { no: 18, name: "process_proposal", kind: "message", T: ProcessProposalResponse, oneof: "value" },
    { no: 19, name: "extend_vote", kind: "message", T: ExtendVoteResponse, oneof: "value" },
    { no: 20, name: "verify_vote_extension", kind: "message", T: VerifyVoteExtensionResponse, oneof: "value" },
    { no: 21, name: "finalize_block", kind: "message", T: FinalizeBlockResponse, oneof: "value" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Response {
    return new Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Response {
    return new Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Response {
    return new Response().fromJsonString(jsonString, options);
  }

  static equals(a: Response | PlainMessage<Response> | undefined, b: Response | PlainMessage<Response> | undefined): boolean {
    return proto3.util.equals(Response, a, b);
  }
}

/**
 * nondeterministic
 *
 * @generated from message cometbft.abci.v1.ExceptionResponse
 */
export class ExceptionResponse extends Message<ExceptionResponse> {
  /**
   * @generated from field: string error = 1;
   */
  error = "";

  constructor(data?: PartialMessage<ExceptionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExceptionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExceptionResponse {
    return new ExceptionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExceptionResponse {
    return new ExceptionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExceptionResponse {
    return new ExceptionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExceptionResponse | PlainMessage<ExceptionResponse> | undefined, b: ExceptionResponse | PlainMessage<ExceptionResponse> | undefined): boolean {
    return proto3.util.equals(ExceptionResponse, a, b);
  }
}

/**
 * EchoResponse indicates that the connection is still alive.
 *
 * @generated from message cometbft.abci.v1.EchoResponse
 */
export class EchoResponse extends Message<EchoResponse> {
  /**
   * @generated from field: string message = 1;
   */
  message = "";

  constructor(data?: PartialMessage<EchoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.EchoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EchoResponse {
    return new EchoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EchoResponse {
    return new EchoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EchoResponse {
    return new EchoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EchoResponse | PlainMessage<EchoResponse> | undefined, b: EchoResponse | PlainMessage<EchoResponse> | undefined): boolean {
    return proto3.util.equals(EchoResponse, a, b);
  }
}

/**
 * FlushResponse indicates that the write buffer was flushed.
 *
 * @generated from message cometbft.abci.v1.FlushResponse
 */
export class FlushResponse extends Message<FlushResponse> {
  constructor(data?: PartialMessage<FlushResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.FlushResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FlushResponse {
    return new FlushResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FlushResponse {
    return new FlushResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FlushResponse {
    return new FlushResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FlushResponse | PlainMessage<FlushResponse> | undefined, b: FlushResponse | PlainMessage<FlushResponse> | undefined): boolean {
    return proto3.util.equals(FlushResponse, a, b);
  }
}

/**
 * InfoResponse contains the ABCI application version information.
 *
 * @generated from message cometbft.abci.v1.InfoResponse
 */
export class InfoResponse extends Message<InfoResponse> {
  /**
   * @generated from field: string data = 1;
   */
  data = "";

  /**
   * @generated from field: string version = 2;
   */
  version = "";

  /**
   * @generated from field: uint64 app_version = 3;
   */
  appVersion = protoInt64.zero;

  /**
   * @generated from field: int64 last_block_height = 4;
   */
  lastBlockHeight = protoInt64.zero;

  /**
   * @generated from field: bytes last_block_app_hash = 5;
   */
  lastBlockAppHash = new Uint8Array(0);

  constructor(data?: PartialMessage<InfoResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.InfoResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "app_version", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "last_block_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "last_block_app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InfoResponse {
    return new InfoResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InfoResponse {
    return new InfoResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InfoResponse {
    return new InfoResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InfoResponse | PlainMessage<InfoResponse> | undefined, b: InfoResponse | PlainMessage<InfoResponse> | undefined): boolean {
    return proto3.util.equals(InfoResponse, a, b);
  }
}

/**
 * InitChainResponse contains the ABCI application's hash and updates to the
 * validator set and/or the consensus params, if any.
 *
 * @generated from message cometbft.abci.v1.InitChainResponse
 */
export class InitChainResponse extends Message<InitChainResponse> {
  /**
   * @generated from field: cometbft.types.v1.ConsensusParams consensus_params = 1;
   */
  consensusParams?: ConsensusParams;

  /**
   * @generated from field: repeated cometbft.abci.v1.ValidatorUpdate validators = 2;
   */
  validators: ValidatorUpdate[] = [];

  /**
   * @generated from field: bytes app_hash = 3;
   */
  appHash = new Uint8Array(0);

  constructor(data?: PartialMessage<InitChainResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.InitChainResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "consensus_params", kind: "message", T: ConsensusParams },
    { no: 2, name: "validators", kind: "message", T: ValidatorUpdate, repeated: true },
    { no: 3, name: "app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitChainResponse {
    return new InitChainResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitChainResponse {
    return new InitChainResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitChainResponse {
    return new InitChainResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitChainResponse | PlainMessage<InitChainResponse> | undefined, b: InitChainResponse | PlainMessage<InitChainResponse> | undefined): boolean {
    return proto3.util.equals(InitChainResponse, a, b);
  }
}

/**
 * QueryResponse contains the ABCI application data along with a proof.
 *
 * @generated from message cometbft.abci.v1.QueryResponse
 */
export class QueryResponse extends Message<QueryResponse> {
  /**
   * @generated from field: uint32 code = 1;
   */
  code = 0;

  /**
   * bytes data = 2; // use "value" instead.
   *
   * nondeterministic
   *
   * @generated from field: string log = 3;
   */
  log = "";

  /**
   * nondeterministic
   *
   * @generated from field: string info = 4;
   */
  info = "";

  /**
   * @generated from field: int64 index = 5;
   */
  index = protoInt64.zero;

  /**
   * @generated from field: bytes key = 6;
   */
  key = new Uint8Array(0);

  /**
   * @generated from field: bytes value = 7;
   */
  value = new Uint8Array(0);

  /**
   * @generated from field: cometbft.crypto.v1.ProofOps proof_ops = 8;
   */
  proofOps?: ProofOps;

  /**
   * @generated from field: int64 height = 9;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: string codespace = 10;
   */
  codespace = "";

  constructor(data?: PartialMessage<QueryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.QueryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "index", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "value", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 8, name: "proof_ops", kind: "message", T: ProofOps },
    { no: 9, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "codespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): QueryResponse {
    return new QueryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): QueryResponse {
    return new QueryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): QueryResponse {
    return new QueryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: QueryResponse | PlainMessage<QueryResponse> | undefined, b: QueryResponse | PlainMessage<QueryResponse> | undefined): boolean {
    return proto3.util.equals(QueryResponse, a, b);
  }
}

/**
 * CheckTxResponse shows if the transaction was deemed valid by the ABCI
 * application.
 *
 * @generated from message cometbft.abci.v1.CheckTxResponse
 */
export class CheckTxResponse extends Message<CheckTxResponse> {
  /**
   * @generated from field: uint32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: bytes data = 2;
   */
  data = new Uint8Array(0);

  /**
   * nondeterministic
   *
   * @generated from field: string log = 3;
   */
  log = "";

  /**
   * nondeterministic
   *
   * @generated from field: string info = 4;
   */
  info = "";

  /**
   * @generated from field: int64 gas_wanted = 5 [json_name = "gas_wanted"];
   */
  gasWanted = protoInt64.zero;

  /**
   * @generated from field: int64 gas_used = 6 [json_name = "gas_used"];
   */
  gasUsed = protoInt64.zero;

  /**
   * nondeterministic
   *
   * @generated from field: repeated cometbft.abci.v1.Event events = 7;
   */
  events: Event[] = [];

  /**
   * @generated from field: string codespace = 8;
   */
  codespace = "";

  constructor(data?: PartialMessage<CheckTxResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.CheckTxResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "gas_wanted", jsonName: "gas_wanted", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "gas_used", jsonName: "gas_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "events", kind: "message", T: Event, repeated: true },
    { no: 8, name: "codespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CheckTxResponse {
    return new CheckTxResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CheckTxResponse {
    return new CheckTxResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CheckTxResponse {
    return new CheckTxResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CheckTxResponse | PlainMessage<CheckTxResponse> | undefined, b: CheckTxResponse | PlainMessage<CheckTxResponse> | undefined): boolean {
    return proto3.util.equals(CheckTxResponse, a, b);
  }
}

/**
 * CommitResponse indicates how much blocks should CometBFT retain.
 *
 * @generated from message cometbft.abci.v1.CommitResponse
 */
export class CommitResponse extends Message<CommitResponse> {
  /**
   * @generated from field: int64 retain_height = 3;
   */
  retainHeight = protoInt64.zero;

  constructor(data?: PartialMessage<CommitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.CommitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 3, name: "retain_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommitResponse {
    return new CommitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommitResponse {
    return new CommitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommitResponse {
    return new CommitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CommitResponse | PlainMessage<CommitResponse> | undefined, b: CommitResponse | PlainMessage<CommitResponse> | undefined): boolean {
    return proto3.util.equals(CommitResponse, a, b);
  }
}

/**
 * ListSnapshotsResponse contains the list of snapshots.
 *
 * @generated from message cometbft.abci.v1.ListSnapshotsResponse
 */
export class ListSnapshotsResponse extends Message<ListSnapshotsResponse> {
  /**
   * @generated from field: repeated cometbft.abci.v1.Snapshot snapshots = 1;
   */
  snapshots: Snapshot[] = [];

  constructor(data?: PartialMessage<ListSnapshotsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ListSnapshotsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "snapshots", kind: "message", T: Snapshot, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSnapshotsResponse {
    return new ListSnapshotsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSnapshotsResponse {
    return new ListSnapshotsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSnapshotsResponse {
    return new ListSnapshotsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSnapshotsResponse | PlainMessage<ListSnapshotsResponse> | undefined, b: ListSnapshotsResponse | PlainMessage<ListSnapshotsResponse> | undefined): boolean {
    return proto3.util.equals(ListSnapshotsResponse, a, b);
  }
}

/**
 * OfferSnapshotResponse indicates the ABCI application decision whenever to
 * provide a snapshot to the requester or not.
 *
 * @generated from message cometbft.abci.v1.OfferSnapshotResponse
 */
export class OfferSnapshotResponse extends Message<OfferSnapshotResponse> {
  /**
   * @generated from field: cometbft.abci.v1.OfferSnapshotResult result = 1;
   */
  result = OfferSnapshotResult.UNKNOWN;

  constructor(data?: PartialMessage<OfferSnapshotResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.OfferSnapshotResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(OfferSnapshotResult) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OfferSnapshotResponse {
    return new OfferSnapshotResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OfferSnapshotResponse {
    return new OfferSnapshotResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OfferSnapshotResponse {
    return new OfferSnapshotResponse().fromJsonString(jsonString, options);
  }

  static equals(a: OfferSnapshotResponse | PlainMessage<OfferSnapshotResponse> | undefined, b: OfferSnapshotResponse | PlainMessage<OfferSnapshotResponse> | undefined): boolean {
    return proto3.util.equals(OfferSnapshotResponse, a, b);
  }
}

/**
 * LoadSnapshotChunkResponse returns a snapshot's chunk.
 *
 * @generated from message cometbft.abci.v1.LoadSnapshotChunkResponse
 */
export class LoadSnapshotChunkResponse extends Message<LoadSnapshotChunkResponse> {
  /**
   * @generated from field: bytes chunk = 1;
   */
  chunk = new Uint8Array(0);

  constructor(data?: PartialMessage<LoadSnapshotChunkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.LoadSnapshotChunkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "chunk", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): LoadSnapshotChunkResponse {
    return new LoadSnapshotChunkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): LoadSnapshotChunkResponse {
    return new LoadSnapshotChunkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): LoadSnapshotChunkResponse {
    return new LoadSnapshotChunkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: LoadSnapshotChunkResponse | PlainMessage<LoadSnapshotChunkResponse> | undefined, b: LoadSnapshotChunkResponse | PlainMessage<LoadSnapshotChunkResponse> | undefined): boolean {
    return proto3.util.equals(LoadSnapshotChunkResponse, a, b);
  }
}

/**
 * ApplySnapshotChunkResponse returns a result of applying the specified chunk.
 *
 * @generated from message cometbft.abci.v1.ApplySnapshotChunkResponse
 */
export class ApplySnapshotChunkResponse extends Message<ApplySnapshotChunkResponse> {
  /**
   * @generated from field: cometbft.abci.v1.ApplySnapshotChunkResult result = 1;
   */
  result = ApplySnapshotChunkResult.UNKNOWN;

  /**
   * Chunks to refetch and reapply
   *
   * @generated from field: repeated uint32 refetch_chunks = 2;
   */
  refetchChunks: number[] = [];

  /**
   * Chunk senders to reject and ban
   *
   * @generated from field: repeated string reject_senders = 3;
   */
  rejectSenders: string[] = [];

  constructor(data?: PartialMessage<ApplySnapshotChunkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ApplySnapshotChunkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "result", kind: "enum", T: proto3.getEnumType(ApplySnapshotChunkResult) },
    { no: 2, name: "refetch_chunks", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 3, name: "reject_senders", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ApplySnapshotChunkResponse {
    return new ApplySnapshotChunkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ApplySnapshotChunkResponse {
    return new ApplySnapshotChunkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ApplySnapshotChunkResponse {
    return new ApplySnapshotChunkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ApplySnapshotChunkResponse | PlainMessage<ApplySnapshotChunkResponse> | undefined, b: ApplySnapshotChunkResponse | PlainMessage<ApplySnapshotChunkResponse> | undefined): boolean {
    return proto3.util.equals(ApplySnapshotChunkResponse, a, b);
  }
}

/**
 * PrepareProposalResponse contains a list of transactions, which will form a block.
 *
 * @generated from message cometbft.abci.v1.PrepareProposalResponse
 */
export class PrepareProposalResponse extends Message<PrepareProposalResponse> {
  /**
   * @generated from field: repeated bytes txs = 1;
   */
  txs: Uint8Array[] = [];

  constructor(data?: PartialMessage<PrepareProposalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.PrepareProposalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "txs", kind: "scalar", T: 12 /* ScalarType.BYTES */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PrepareProposalResponse {
    return new PrepareProposalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PrepareProposalResponse {
    return new PrepareProposalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PrepareProposalResponse {
    return new PrepareProposalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PrepareProposalResponse | PlainMessage<PrepareProposalResponse> | undefined, b: PrepareProposalResponse | PlainMessage<PrepareProposalResponse> | undefined): boolean {
    return proto3.util.equals(PrepareProposalResponse, a, b);
  }
}

/**
 * ProcessProposalResponse indicates the ABCI application's decision whenever
 * the given proposal should be accepted or not.
 *
 * @generated from message cometbft.abci.v1.ProcessProposalResponse
 */
export class ProcessProposalResponse extends Message<ProcessProposalResponse> {
  /**
   * @generated from field: cometbft.abci.v1.ProcessProposalStatus status = 1;
   */
  status = ProcessProposalStatus.UNKNOWN;

  constructor(data?: PartialMessage<ProcessProposalResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ProcessProposalResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(ProcessProposalStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProcessProposalResponse {
    return new ProcessProposalResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProcessProposalResponse {
    return new ProcessProposalResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProcessProposalResponse {
    return new ProcessProposalResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ProcessProposalResponse | PlainMessage<ProcessProposalResponse> | undefined, b: ProcessProposalResponse | PlainMessage<ProcessProposalResponse> | undefined): boolean {
    return proto3.util.equals(ProcessProposalResponse, a, b);
  }
}

/**
 * ExtendVoteResponse contains the vote extension that the application would like to
 * attach to its next precommit vote.
 *
 * @generated from message cometbft.abci.v1.ExtendVoteResponse
 */
export class ExtendVoteResponse extends Message<ExtendVoteResponse> {
  /**
   * @generated from field: bytes vote_extension = 1;
   */
  voteExtension = new Uint8Array(0);

  constructor(data?: PartialMessage<ExtendVoteResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExtendVoteResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "vote_extension", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendVoteResponse {
    return new ExtendVoteResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendVoteResponse {
    return new ExtendVoteResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendVoteResponse {
    return new ExtendVoteResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendVoteResponse | PlainMessage<ExtendVoteResponse> | undefined, b: ExtendVoteResponse | PlainMessage<ExtendVoteResponse> | undefined): boolean {
    return proto3.util.equals(ExtendVoteResponse, a, b);
  }
}

/**
 * VerifyVoteExtensionResponse indicates the ABCI application's decision
 * whenever the vote extension should be accepted or not.
 *
 * @generated from message cometbft.abci.v1.VerifyVoteExtensionResponse
 */
export class VerifyVoteExtensionResponse extends Message<VerifyVoteExtensionResponse> {
  /**
   * @generated from field: cometbft.abci.v1.VerifyVoteExtensionStatus status = 1;
   */
  status = VerifyVoteExtensionStatus.UNKNOWN;

  constructor(data?: PartialMessage<VerifyVoteExtensionResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.VerifyVoteExtensionResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "status", kind: "enum", T: proto3.getEnumType(VerifyVoteExtensionStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyVoteExtensionResponse {
    return new VerifyVoteExtensionResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyVoteExtensionResponse {
    return new VerifyVoteExtensionResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyVoteExtensionResponse {
    return new VerifyVoteExtensionResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyVoteExtensionResponse | PlainMessage<VerifyVoteExtensionResponse> | undefined, b: VerifyVoteExtensionResponse | PlainMessage<VerifyVoteExtensionResponse> | undefined): boolean {
    return proto3.util.equals(VerifyVoteExtensionResponse, a, b);
  }
}

/**
 * FinalizeBlockResponse contains the result of executing the block.
 *
 * @generated from message cometbft.abci.v1.FinalizeBlockResponse
 */
export class FinalizeBlockResponse extends Message<FinalizeBlockResponse> {
  /**
   * set of block events emitted as part of executing the block
   *
   * nondeterministic
   *
   * @generated from field: repeated cometbft.abci.v1.Event events = 1;
   */
  events: Event[] = [];

  /**
   * the result of executing each transaction including the events
   * the particular transaction emitted. This should match the order
   * of the transactions delivered in the block itself
   *
   * @generated from field: repeated cometbft.abci.v1.ExecTxResult tx_results = 2;
   */
  txResults: ExecTxResult[] = [];

  /**
   * a list of updates to the validator set. These will reflect the validator set at current height + 2.
   *
   * @generated from field: repeated cometbft.abci.v1.ValidatorUpdate validator_updates = 3;
   */
  validatorUpdates: ValidatorUpdate[] = [];

  /**
   * updates to the consensus params, if any.
   *
   * @generated from field: cometbft.types.v1.ConsensusParams consensus_param_updates = 4;
   */
  consensusParamUpdates?: ConsensusParams;

  /**
   * app_hash is the hash of the applications' state which is used to confirm
   * that execution of the transactions was deterministic.
   * It is up to the application to decide which algorithm to use.
   *
   * @generated from field: bytes app_hash = 5;
   */
  appHash = new Uint8Array(0);

  constructor(data?: PartialMessage<FinalizeBlockResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.FinalizeBlockResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
    { no: 2, name: "tx_results", kind: "message", T: ExecTxResult, repeated: true },
    { no: 3, name: "validator_updates", kind: "message", T: ValidatorUpdate, repeated: true },
    { no: 4, name: "consensus_param_updates", kind: "message", T: ConsensusParams },
    { no: 5, name: "app_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FinalizeBlockResponse {
    return new FinalizeBlockResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FinalizeBlockResponse {
    return new FinalizeBlockResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FinalizeBlockResponse {
    return new FinalizeBlockResponse().fromJsonString(jsonString, options);
  }

  static equals(a: FinalizeBlockResponse | PlainMessage<FinalizeBlockResponse> | undefined, b: FinalizeBlockResponse | PlainMessage<FinalizeBlockResponse> | undefined): boolean {
    return proto3.util.equals(FinalizeBlockResponse, a, b);
  }
}

/**
 * CommitInfo contains votes for the particular round.
 *
 * @generated from message cometbft.abci.v1.CommitInfo
 */
export class CommitInfo extends Message<CommitInfo> {
  /**
   * @generated from field: int32 round = 1;
   */
  round = 0;

  /**
   * @generated from field: repeated cometbft.abci.v1.VoteInfo votes = 2;
   */
  votes: VoteInfo[] = [];

  constructor(data?: PartialMessage<CommitInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.CommitInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "votes", kind: "message", T: VoteInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CommitInfo {
    return new CommitInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CommitInfo {
    return new CommitInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CommitInfo {
    return new CommitInfo().fromJsonString(jsonString, options);
  }

  static equals(a: CommitInfo | PlainMessage<CommitInfo> | undefined, b: CommitInfo | PlainMessage<CommitInfo> | undefined): boolean {
    return proto3.util.equals(CommitInfo, a, b);
  }
}

/**
 * ExtendedCommitInfo is similar to CommitInfo except that it is only used in
 * the PrepareProposal request such that Tendermint can provide vote extensions
 * to the application.
 *
 * @generated from message cometbft.abci.v1.ExtendedCommitInfo
 */
export class ExtendedCommitInfo extends Message<ExtendedCommitInfo> {
  /**
   * The round at which the block proposer decided in the previous height.
   *
   * @generated from field: int32 round = 1;
   */
  round = 0;

  /**
   * List of validators' addresses in the last validator set with their voting
   * information, including vote extensions.
   *
   * @generated from field: repeated cometbft.abci.v1.ExtendedVoteInfo votes = 2;
   */
  votes: ExtendedVoteInfo[] = [];

  constructor(data?: PartialMessage<ExtendedCommitInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExtendedCommitInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "round", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "votes", kind: "message", T: ExtendedVoteInfo, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendedCommitInfo {
    return new ExtendedCommitInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendedCommitInfo {
    return new ExtendedCommitInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendedCommitInfo {
    return new ExtendedCommitInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendedCommitInfo | PlainMessage<ExtendedCommitInfo> | undefined, b: ExtendedCommitInfo | PlainMessage<ExtendedCommitInfo> | undefined): boolean {
    return proto3.util.equals(ExtendedCommitInfo, a, b);
  }
}

/**
 * Event allows application developers to attach additional information to
 * ResponseFinalizeBlock and ResponseCheckTx.
 * Up to 0.37, this could also be used in ResponseBeginBlock, ResponseEndBlock,
 * and ResponseDeliverTx.
 * Later, transactions may be queried using these events.
 *
 * @generated from message cometbft.abci.v1.Event
 */
export class Event extends Message<Event> {
  /**
   * @generated from field: string type = 1;
   */
  type = "";

  /**
   * @generated from field: repeated cometbft.abci.v1.EventAttribute attributes = 2;
   */
  attributes: EventAttribute[] = [];

  constructor(data?: PartialMessage<Event>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Event";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "attributes", kind: "message", T: EventAttribute, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Event {
    return new Event().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Event {
    return new Event().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Event {
    return new Event().fromJsonString(jsonString, options);
  }

  static equals(a: Event | PlainMessage<Event> | undefined, b: Event | PlainMessage<Event> | undefined): boolean {
    return proto3.util.equals(Event, a, b);
  }
}

/**
 * EventAttribute is a single key-value pair, associated with an event.
 *
 * @generated from message cometbft.abci.v1.EventAttribute
 */
export class EventAttribute extends Message<EventAttribute> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  /**
   * nondeterministic
   *
   * @generated from field: bool index = 3;
   */
  index = false;

  constructor(data?: PartialMessage<EventAttribute>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.EventAttribute";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "index", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EventAttribute {
    return new EventAttribute().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EventAttribute {
    return new EventAttribute().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EventAttribute {
    return new EventAttribute().fromJsonString(jsonString, options);
  }

  static equals(a: EventAttribute | PlainMessage<EventAttribute> | undefined, b: EventAttribute | PlainMessage<EventAttribute> | undefined): boolean {
    return proto3.util.equals(EventAttribute, a, b);
  }
}

/**
 * ExecTxResult contains results of executing one individual transaction.
 *
 * * Its structure is equivalent to #ResponseDeliverTx which will be deprecated/deleted
 *
 * @generated from message cometbft.abci.v1.ExecTxResult
 */
export class ExecTxResult extends Message<ExecTxResult> {
  /**
   * @generated from field: uint32 code = 1;
   */
  code = 0;

  /**
   * @generated from field: bytes data = 2;
   */
  data = new Uint8Array(0);

  /**
   * nondeterministic
   *
   * @generated from field: string log = 3;
   */
  log = "";

  /**
   * nondeterministic
   *
   * @generated from field: string info = 4;
   */
  info = "";

  /**
   * @generated from field: int64 gas_wanted = 5 [json_name = "gas_wanted"];
   */
  gasWanted = protoInt64.zero;

  /**
   * @generated from field: int64 gas_used = 6 [json_name = "gas_used"];
   */
  gasUsed = protoInt64.zero;

  /**
   * nondeterministic
   *
   * @generated from field: repeated cometbft.abci.v1.Event events = 7;
   */
  events: Event[] = [];

  /**
   * @generated from field: string codespace = 8;
   */
  codespace = "";

  constructor(data?: PartialMessage<ExecTxResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExecTxResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "info", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "gas_wanted", jsonName: "gas_wanted", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "gas_used", jsonName: "gas_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "events", kind: "message", T: Event, repeated: true },
    { no: 8, name: "codespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExecTxResult {
    return new ExecTxResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExecTxResult {
    return new ExecTxResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExecTxResult {
    return new ExecTxResult().fromJsonString(jsonString, options);
  }

  static equals(a: ExecTxResult | PlainMessage<ExecTxResult> | undefined, b: ExecTxResult | PlainMessage<ExecTxResult> | undefined): boolean {
    return proto3.util.equals(ExecTxResult, a, b);
  }
}

/**
 * TxResult contains results of executing the transaction.
 *
 * One usage is indexing transaction results.
 *
 * @generated from message cometbft.abci.v1.TxResult
 */
export class TxResult extends Message<TxResult> {
  /**
   * @generated from field: int64 height = 1;
   */
  height = protoInt64.zero;

  /**
   * @generated from field: uint32 index = 2;
   */
  index = 0;

  /**
   * @generated from field: bytes tx = 3;
   */
  tx = new Uint8Array(0);

  /**
   * @generated from field: cometbft.abci.v1.ExecTxResult result = 4;
   */
  result?: ExecTxResult;

  constructor(data?: PartialMessage<TxResult>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.TxResult";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "index", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "tx", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "result", kind: "message", T: ExecTxResult },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TxResult {
    return new TxResult().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TxResult {
    return new TxResult().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TxResult {
    return new TxResult().fromJsonString(jsonString, options);
  }

  static equals(a: TxResult | PlainMessage<TxResult> | undefined, b: TxResult | PlainMessage<TxResult> | undefined): boolean {
    return proto3.util.equals(TxResult, a, b);
  }
}

/**
 * Validator in the validator set.
 *
 * @generated from message cometbft.abci.v1.Validator
 */
export class Validator extends Message<Validator> {
  /**
   * The first 20 bytes of SHA256(public key)
   *
   * @generated from field: bytes address = 1;
   */
  address = new Uint8Array(0);

  /**
   * PubKey pub_key = 2 [(gogoproto.nullable)=false];
   *
   * The voting power
   *
   * @generated from field: int64 power = 3;
   */
  power = protoInt64.zero;

  constructor(data?: PartialMessage<Validator>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Validator";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Validator {
    return new Validator().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Validator {
    return new Validator().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Validator {
    return new Validator().fromJsonString(jsonString, options);
  }

  static equals(a: Validator | PlainMessage<Validator> | undefined, b: Validator | PlainMessage<Validator> | undefined): boolean {
    return proto3.util.equals(Validator, a, b);
  }
}

/**
 * ValidatorUpdate is a singular update to a validator set.
 *
 * @generated from message cometbft.abci.v1.ValidatorUpdate
 */
export class ValidatorUpdate extends Message<ValidatorUpdate> {
  /**
   * @generated from field: cometbft.crypto.v1.PublicKey pub_key = 1;
   */
  pubKey?: PublicKey;

  /**
   * @generated from field: int64 power = 2;
   */
  power = protoInt64.zero;

  constructor(data?: PartialMessage<ValidatorUpdate>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ValidatorUpdate";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pub_key", kind: "message", T: PublicKey },
    { no: 2, name: "power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidatorUpdate {
    return new ValidatorUpdate().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidatorUpdate {
    return new ValidatorUpdate().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidatorUpdate {
    return new ValidatorUpdate().fromJsonString(jsonString, options);
  }

  static equals(a: ValidatorUpdate | PlainMessage<ValidatorUpdate> | undefined, b: ValidatorUpdate | PlainMessage<ValidatorUpdate> | undefined): boolean {
    return proto3.util.equals(ValidatorUpdate, a, b);
  }
}

/**
 * VoteInfo contains the information about the vote.
 *
 * @generated from message cometbft.abci.v1.VoteInfo
 */
export class VoteInfo extends Message<VoteInfo> {
  /**
   * @generated from field: cometbft.abci.v1.Validator validator = 1;
   */
  validator?: Validator;

  /**
   * @generated from field: cometbft.types.v1.BlockIDFlag block_id_flag = 3;
   */
  blockIdFlag = BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;

  constructor(data?: PartialMessage<VoteInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.VoteInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "validator", kind: "message", T: Validator },
    { no: 3, name: "block_id_flag", kind: "enum", T: proto3.getEnumType(BlockIDFlag) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VoteInfo {
    return new VoteInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VoteInfo {
    return new VoteInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VoteInfo {
    return new VoteInfo().fromJsonString(jsonString, options);
  }

  static equals(a: VoteInfo | PlainMessage<VoteInfo> | undefined, b: VoteInfo | PlainMessage<VoteInfo> | undefined): boolean {
    return proto3.util.equals(VoteInfo, a, b);
  }
}

/**
 * ExtendedVoteInfo extends VoteInfo with the vote extensions (non-deterministic).
 *
 * @generated from message cometbft.abci.v1.ExtendedVoteInfo
 */
export class ExtendedVoteInfo extends Message<ExtendedVoteInfo> {
  /**
   * The validator that sent the vote.
   *
   * @generated from field: cometbft.abci.v1.Validator validator = 1;
   */
  validator?: Validator;

  /**
   * Non-deterministic extension provided by the sending validator's application.
   *
   * @generated from field: bytes vote_extension = 3;
   */
  voteExtension = new Uint8Array(0);

  /**
   * Vote extension signature created by CometBFT
   *
   * @generated from field: bytes extension_signature = 4;
   */
  extensionSignature = new Uint8Array(0);

  /**
   * block_id_flag indicates whether the validator voted for a block, nil, or did not vote at all
   *
   * @generated from field: cometbft.types.v1.BlockIDFlag block_id_flag = 5;
   */
  blockIdFlag = BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;

  constructor(data?: PartialMessage<ExtendedVoteInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.ExtendedVoteInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "validator", kind: "message", T: Validator },
    { no: 3, name: "vote_extension", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "extension_signature", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "block_id_flag", kind: "enum", T: proto3.getEnumType(BlockIDFlag) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExtendedVoteInfo {
    return new ExtendedVoteInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExtendedVoteInfo {
    return new ExtendedVoteInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExtendedVoteInfo {
    return new ExtendedVoteInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ExtendedVoteInfo | PlainMessage<ExtendedVoteInfo> | undefined, b: ExtendedVoteInfo | PlainMessage<ExtendedVoteInfo> | undefined): boolean {
    return proto3.util.equals(ExtendedVoteInfo, a, b);
  }
}

/**
 * Misbehavior is a type of misbehavior committed by a validator.
 *
 * @generated from message cometbft.abci.v1.Misbehavior
 */
export class Misbehavior extends Message<Misbehavior> {
  /**
   * @generated from field: cometbft.abci.v1.MisbehaviorType type = 1;
   */
  type = MisbehaviorType.UNKNOWN;

  /**
   * The offending validator
   *
   * @generated from field: cometbft.abci.v1.Validator validator = 2;
   */
  validator?: Validator;

  /**
   * The height when the offense occurred
   *
   * @generated from field: int64 height = 3;
   */
  height = protoInt64.zero;

  /**
   * The corresponding time where the offense occurred
   *
   * @generated from field: google.protobuf.Timestamp time = 4;
   */
  time?: Timestamp;

  /**
   * Total voting power of the validator set in case the ABCI application does
   * not store historical validators.
   * https://github.com/tendermint/tendermint/issues/4581
   *
   * @generated from field: int64 total_voting_power = 5;
   */
  totalVotingPower = protoInt64.zero;

  constructor(data?: PartialMessage<Misbehavior>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Misbehavior";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(MisbehaviorType) },
    { no: 2, name: "validator", kind: "message", T: Validator },
    { no: 3, name: "height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "time", kind: "message", T: Timestamp },
    { no: 5, name: "total_voting_power", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Misbehavior {
    return new Misbehavior().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Misbehavior {
    return new Misbehavior().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Misbehavior {
    return new Misbehavior().fromJsonString(jsonString, options);
  }

  static equals(a: Misbehavior | PlainMessage<Misbehavior> | undefined, b: Misbehavior | PlainMessage<Misbehavior> | undefined): boolean {
    return proto3.util.equals(Misbehavior, a, b);
  }
}

/**
 * Snapshot of the ABCI application state.
 *
 * @generated from message cometbft.abci.v1.Snapshot
 */
export class Snapshot extends Message<Snapshot> {
  /**
   * The height at which the snapshot was taken
   *
   * @generated from field: uint64 height = 1;
   */
  height = protoInt64.zero;

  /**
   * The application-specific snapshot format
   *
   * @generated from field: uint32 format = 2;
   */
  format = 0;

  /**
   * Number of chunks in the snapshot
   *
   * @generated from field: uint32 chunks = 3;
   */
  chunks = 0;

  /**
   * Arbitrary snapshot hash, equal only if identical
   *
   * @generated from field: bytes hash = 4;
   */
  hash = new Uint8Array(0);

  /**
   * Arbitrary application metadata
   *
   * @generated from field: bytes metadata = 5;
   */
  metadata = new Uint8Array(0);

  constructor(data?: PartialMessage<Snapshot>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.abci.v1.Snapshot";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "format", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "chunks", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "metadata", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Snapshot {
    return new Snapshot().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Snapshot {
    return new Snapshot().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Snapshot {
    return new Snapshot().fromJsonString(jsonString, options);
  }

  static equals(a: Snapshot | PlainMessage<Snapshot> | undefined, b: Snapshot | PlainMessage<Snapshot> | undefined): boolean {
    return proto3.util.equals(Snapshot, a, b);
  }
}

